module.exports = __webpack_public_path__ + "9779d9a1/img/google.68f3823e.svg";